import axios from 'axios';
import configureStore from '../store/store';

let CancelToken = axios.CancelToken;
let cancelTokens = {};

const addCancelToken = (url) => {
    const key = generateKey(url);
    cancelTokens[key] = CancelToken.source();
};

const getCancelToken = (url) => {
    const key = generateKey(url);

    return cancelTokens[key] ?
        cancelTokens[key].token :
        null;
};

const cancelRequest = (url) => {
    const key = generateKey(url);

    if (cancelTokens[key]) {
        cancelTokens[key].cancel(url + ' cancelled');
        removeCancelToken(url);
    }
};

const removeCancelToken = (url) => {
    const key = generateKey(url);

    if (cancelTokens[key]) {
        cancelTokens[key] = undefined;
    }
};

// Two different practices can call the exact same relative endpoint path
// (the practice is disambiguated by a groupId sent in the request itself,
// not by the path text). Fold in the currently active group so their
// in-flight requests never collide on the same cancel-token slot.
const generateKey = (url) => {
    const { group } = configureStore().getState();
    const groupSuffix = group && group.id ? ':' + group.id : '';

    return url.replace(/\//g, '') + groupSuffix;
}

export const UtilApi = {
    addCancelToken,
    cancelRequest,
    getCancelToken,
    removeCancelToken
};

document.addEventListener('cancelRequests', (e) => {
    const { requests } = e.detail;

    requests.forEach((request) => {
        cancelRequest(request);
    });
});